module.exports = __webpack_public_path__ + "static/decima-nova-pro-regular-79ed5dbcab928edd44d8043eed34e4a8.woff2";